import { render, staticRenderFns } from "./download-data.vue?vue&type=template&id=c2e17336"
import script from "./download-data.vue?vue&type=script&lang=js"
export * from "./download-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports